import { createFileRoute } from '@tanstack/react-router'
import { LoginReportPage } from '@/features/reports/logins'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/reports/logins')({
  component: () => (
    <RequirePermission permission='report.logins.view'>
      <LoginReportPage />
    </RequirePermission>
  ),
})
